// @flow
import * as React from 'react';
import {FlagIcon} from 'docs/components/core/FlagIcon/FlagIcon';
import type {FlagCountryCode} from 'docs/components/core/FlagIcon/FlagIcon';
import {countryNameMessages} from 'docs/components/contrib/Terminal/countries';
import {FormattedMessage, defineMessages} from 'react-intl';

type TerminalHardwareOrdersCountriesProps = {|
  countries: Array<FlagCountryCode>,
|};

export const countryExceptionMessages = defineMessages({
  US: {
    id: 'docsShell.TerminalHardwareOrderCountries.countryException.US',
    description:
      'Aside describing delivery exceptions for ordering Terminal hardware in the US',
    defaultMessage: '(excluding Puerto Rico)',
  },
});

export const TerminalHardwareOrdersCountries = ({
  countries,
}: TerminalHardwareOrdersCountriesProps) => {
  if (!countries || countries.length === 0) {
    return null;
  }

  return (
    <p>
      {countries.map((country) => (
        <FlagIcon
          key={country}
          country={country}
          title={country}
          label={
            // $FlowExpectedError FlagIcon is very strongly typed, but we want the label to be localized
            <>
              <FormattedMessage {...countryNameMessages[country]} />
              {countryExceptionMessages[country] && (
                <span>
                  &nbsp;
                  <FormattedMessage {...countryExceptionMessages[country]} />
                </span>
              )}
            </>
          }
          inline={false}
        />
      ))}
    </p>
  );
};
